import CommuneState from '@/types/store/CommuneState';

const state: CommuneState = {
  communes: [],
};

export default state;
